import CommonMemberTable from "../commonModule/CommonMemberTable";

const ShortfallMemberList = () => {
    return <CommonMemberTable status="Shortfall" title="Shortfall Members" />;
};

export default ShortfallMemberList;